export function createStatCard(label: string, value: string | number, sub?: string, color?: string, borderColor?: string): HTMLElement {
  const card = document.createElement('div');
  card.className = 'stat-card';
  if (borderColor) {
    card.style.borderTop = `3px solid ${borderColor}`;
  }
  card.innerHTML = `
    <p class="text-sm text-gray-500 mb-1">${label}</p>
    <p class="text-2xl font-bold ${color || 'text-gray-900'}">${value}</p>
    ${sub ? `<p class="text-xs text-gray-400 mt-1">${sub}</p>` : ''}
  `;
  return card;
}

export function createPropertyCard(p: { id: string; address: string; suburb: string; state: string; postcode: string; weekly_rent: number; tenant_name: string; lease_end_date: string }): HTMLElement {
  const card = document.createElement('a');
  card.href = `#/properties/${p.id}`;
  card.className = 'card hover:shadow-md transition-shadow cursor-pointer block';

  const daysLeft = p.lease_end_date ? Math.ceil((new Date(p.lease_end_date).getTime() - Date.now()) / 86400000) : null;
  const leaseStatus = daysLeft !== null
    ? daysLeft < 0 ? '<span class="badge badge-red">Expired</span>'
      : daysLeft < 80 ? `<span class="badge badge-yellow">${daysLeft}d left</span>`
      : `<span class="badge badge-green">${daysLeft}d left</span>`
    : '';

  card.innerHTML = `
    <div class="flex justify-between items-start mb-2">
      <div>
        <h3 class="font-semibold text-gray-900">${p.address}</h3>
        <p class="text-sm text-gray-500">${p.suburb}, ${p.state} ${p.postcode}</p>
      </div>
      ${leaseStatus}
    </div>
    <div class="flex justify-between items-center text-sm mt-3 pt-3 border-t border-gray-100">
      <span class="text-gray-500">Tenant: ${p.tenant_name || '—'}</span>
      <span class="font-semibold text-primary-700">$${p.weekly_rent?.toFixed(0) || '0'}/wk</span>
    </div>
  `;
  return card;
}
